module.exports = __webpack_public_path__ + "officialStatic/img/inv.e89c7da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/inv.png
// module id = pomf
// module chunks = 0